module.exports = __webpack_public_path__ + "img/bottomicon (3).4e8c5c43.png";